<template>
  <div id="pageBottmOprate" class="page-bottom-fixed">
    <!-- 手机端二维码 -->
    <div
      class="page-bottom-item"
      @mouseenter="showQrcode = true"
      @mouseleave="showQrcode = false"
    >
      <a class="go-qrcode jsFixedCode" href="javascript:">
        <span class="loop loop1">
          <em class="icon icon-code"></em>
          <p class="icon-txt">手机端</p>
        </span>
      </a>
      <div v-show="showQrcode" class="bototm-qrcode">
        <p class="title">起点中文网发出的红包，新用户14天免费读</p>
        <div class="qrcode-panel">
          <i class="qd-logo"></i>
          <DdlQrcode
            class="auto-tr"
            :show="showQrcode"
            :width="100"
            data-eid="qd_H_mall_download"
            :data-bid="bookId || ''"
            :book-id="Number(bookId)"
            chapter-id=""
            dl-track="qd_H_mall_download"
          ></DdlQrcode>
          <p class="desc">扫码下载APP领取</p>
          <p class="main">内存占用小看书更流畅</p>
        </div>
      </div>
    </div>

    <!-- 桌面版下载（条件显示） -->
    <template v-if="isInWindows">
      <div class="page-bottom-item item-listen">
        <a
          id="bottomDeskDownload"
          data-l7="1"
          data-eid="qd_A_mall_zhuomiandownload"
          class="go-windows item-link-txt"
          href="https://down.pc.yyb.qq.com/packing/3c25016cde98caefd1e7c1d7db2886ed/com.qidian.QDReader_2500100000_installer.exe"
          rel="nofollow"
        >
          <em class="iconfont icon-windows">&#xe907;</em>
          <span class="txt">桌面版</span>
        </a>
        <p id="bottomDeskTips" class="windows-tips dn">
          桌面版已上线，客户端体验更丝滑
        </p>
      </div>
    </template>

    <!-- 返回顶部 -->
    <div
      id="pageBottomGoTop"
      class="page-bottom-item"
      :class="{ dn: !isShowGoTop }"
    >
      <a
        class="go-top"
        href="javascript:"
        aria-label="返回顶部"
        @click="handleGoTop"
      >
        <em class="icon icon-gotop">
          <y-icon class-prefix="qd-icon" name="00302" size=".12rem" />
        </em>
      </a>
    </div>
  </div>

  <!-- 底部活动广告（始终隐藏） -->
  <div v-if="false" id="bottomAd" class="bottom-act dn">
    <i class="bg-red"></i>
    <div class="bottom-main-act">
      <a class="bottom-close jsHDClose" href="javascript:"></a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import YIcon from 'y-design-ssr/libs/icon'
import 'y-design-ssr/libs/icon/index.css'
import DdlQrcode from '@/common/components/DdlQrcode.vue'

defineProps({
  bookId: {
    type: String,
    default: () => {
      return {}
    },
  },
})
const uaIsWin = (
  ua = typeof window === 'undefined' ? '' : navigator.userAgent,
) => {
  const currentAgent = ua.toLowerCase()

  if (
    currentAgent.indexOf('win32') >= 0 ||
    currentAgent.indexOf('win64') >= 0 ||
    currentAgent.indexOf('wow32') >= 0 ||
    currentAgent.indexOf('wow64') >= 0 ||
    currentAgent.indexOf('windows') >= 0
  ) {
    return true
  }

  return false
}

const showQrcode = ref(false)
const isInWindows = uaIsWin()

const isShowGoTop = ref(false)
let scrollTimer: ReturnType<typeof setTimeout> | null = null

const handleScroll = () => {
  if (scrollTimer) clearTimeout(scrollTimer)
  scrollTimer = setTimeout(() => {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    isShowGoTop.value = scrollTop >= 500
  }, 30)
}

const handleGoTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
  handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  if (scrollTimer) clearTimeout(scrollTimer)
})
</script>

<style lang="scss" module>
.bookstore {
  color: black;
  display: inline-block;
  font-size: 24px;
  vertical-align: middle;
}
</style>
<style lang="scss" scoped>
@import '@share/assets/font/qd-icon.scss';
.page-bottom-fixed {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  bottom: 64px;
  // right: 32px;
  // width: 200px;
  z-index: 101;
  text-align: right;
  width: 64px;
  .page-bottom-item {
    position: relative;
    display: block;
    width: 64px;
    height: 64px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.08);
    opacity: 1;
    visibility: visible;
    transition: all 0.2s;
    &.dn {
      opacity: 0;
      visibility: hidden;
    }
    .item-link-txt {
      position: relative;
      display: block;
      em {
        display: block;
        width: 24px;
        height: 24px;
        margin: 10px 20px 0;
      }
      .red-text {
        position: absolute;
        top: -8px;
        font-size: 0;
        margin: auto;
        width: 53px;
        height: 14px;
        left: 30px;
        background: url('https://imgservices-1252317822.image.myqcloud.com/coco/s06162023/e874e343.9jsx1v.png')
          no-repeat center / 100% 100%;
      }
      .txt {
        display: block;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #808080;
        margin-top: 2px;
      }
    }
    .icon-shelf {
      font-size: 24px;
    }
    .windows-tips {
      position: absolute;
      padding: 7px 12px;
      background-color: #333333;
      border-radius: 8px;
      font-size: 14px;
      line-height: 22px;
      color: #fff;
      width: 212px;
      right: 72px;
      top: 14px;
      text-align: left;
      animation: bottomTips 5s forwards;
      &::before {
        content: '';
        position: absolute;
        right: -7px;
        border-width: 8px 0 8px 8px;
        border-style: solid;
        border-color: transparent transparent transparent #333;
      }
      &.dn {
        display: none;
      }
    }
    @keyframes bottomTips {
      0% {
        opacity: 0;
      }
      1% {
        opacity: 1;
      }
      99% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
  .bototm-qrcode {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 180px;
    height: 349px;
    background-color: #fff;
    transition: all 0.2s;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    .title {
      font-size: 0;
      width: 140px;
      height: 88px;
      background: no-repeat
          url('https://imgservices-1252317822.image.myqcloud.com/coco/s10112022/9c2220c2.pi26hr.png'),
        center/100%;
      background-size: 100% 100%;
      margin: 32px 20px;
    }
    .qrcode-con {
      width: 100px;
      height: 100px;
      margin: 12px auto;
      background-color: #fff;
      background: url('https://imgservices-1252317822.image.myqcloud.com/coco/s11142022/c1cd8cc3.xfneul.png')
        no-repeat center 100%/100%;
      canvas,
      img {
        width: 100%;
        height: 100%;
      }
    }
    .desc {
      font-weight: 600;
      font-size: 12px;
      line-height: 17px;
    }
    .main {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: #e5353e;
    }
  }
  .go-qrcode {
    display: block;
    position: relative;
    cursor: pointer;
    width: 64px;
    height: 64px;
    overflow: hidden;
    .loop {
      // opacity: 0;
      position: absolute;
      display: block;
      // display: inline-block;
      top: 0;
      left: 0;
      right: 0;
    }
    .icon-scan {
      margin: 10px auto 2px auto;
      background-image: url('https://imgservices-1252317822.image.myqcloud.com/coco/s10182022/62ca64cd.3j71rc.png');
    }
    .icon-redbag {
      margin: 10px auto 2px auto;
      background-image: url('https://imgservices-1252317822.image.myqcloud.com/coco/s10182022/923fa406.au7qcn.png');
    }
  }
  .go-listen,
  .go-windows {
    display: block;
    position: relative;
    .icon-listen,
    .icon-windows {
      width: 24px;
      height: 24px;
      margin-top: 10px;
      margin-bottom: 0;
    }
    .txt {
      display: block;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      color: #808080;
      margin-top: 2px;
    }
  }
  .qrcode-panel {
    position: relative;
  }
  .qd-logo {
    position: absolute;
    left: 0;
    right: 0;
    top: 36px;
    margin: auto;
    display: block;
    width: 28px;
    height: 28px;
    background: url('https://imgservices-1252317822.image.myqcloud.com/coco/s11022022/43dddf20.il61if.svg')
      no-repeat center 100%/100%;
  }
  .go-top {
    display: block;
    right: inherit;
    bottom: inherit;
  }
  .icon {
    display: block;
    width: 24px;
    height: 24px;
    background: no-repeat
        url('https://imgservices-1252317822.image.myqcloud.com/coco/s10112022/0b2079bd.9yrbjz.png'),
      center/100%;
    background-size: 100% 100%;
    margin: 20px;
  }
  .icon-code {
    background-image: url('https://imgservices-1252317822.image.myqcloud.com/coco/s10182022/62ca64cd.3j71rc.png');
    margin: 10px 20px 2px 20px;
  }
  .icon-txt {
    font-size: 12px;
    line-height: 20px;
    color: #808080;
    text-align: center;
  }
}
@media screen and (min-width: 1248px) {
  .page-bottom-fixed {
    opacity: 1;
    visibility: visible;
    right: 64px;
  }
}

.bottom-act {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  overflow-x: scroll;
  overflow-y: hidden;
  &.dn {
    display: none;
  }
  .bg-red {
    position: absolute;
    display: block;
    right: 0;
    left: 0;
    height: 64px;
    bottom: 0;
    background: url('https://imgservices-1252317822.image.myqcloud.com/coco/s11292022/f5363c8b.abatc4.png')
      repeat-x center;
    border-top: 3px solid #fff;
  }
  .bottom-main-act {
    position: relative;
    // max-width: 1418px;
    width: 822px;
    height: 200px;
    margin: auto;
    background: url('https://imgservices-1252317822.image.myqcloud.com/coco/s12142022/b6455146.mo6q0c.png')
      no-repeat center / 100%;
    img {
      max-width: 100%;
      margin: auto auto -5px;
    }
    .bottom-close {
      position: absolute;
      display: block;
      width: 38px;
      height: 38px;
      top: 0;
      right: 0;
      background: url('https://imgservices-1252317822.image.myqcloud.com/coco/s11152022/c3073bc5.mhueq8.png')
        no-repeat center / 100%;
      transition: 0.2s;
      &:hover {
        transform: rotateZ(360deg);
      }
    }
  }
}

@media screen and (min-width: 1800px) {
  .bottom-act {
    z-index: 102;
    .bottom-main-act {
      max-width: 1418px;
      width: 1418px;
      height: 345px;
    }
    .bg-red {
      height: 111px;
      border-width: 5px;
    }
    .close {
      width: 66px;
      height: 66px;
    }
  }
}
</style>
